import { mode } from "@chakra-ui/theme-tools";
const Card = {
  baseStyle: (props) => ({
    boxSizing: "border-box",
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    position: "relative",
    borderRadius: "10px",
    height: "100%",
    minWidth: "0px",
    wordWrap: "break-word",

    backgroundColor: mode("#ffffff", "navy.800")(props),
    backgroundClip: "border-box",
    boxShadow: "0px 3px 8px rgba(0, 0, 0, 0.24)"
  })
};

export const CardComponent = {
  components: {
    Card
  }
};
